import { createStyles, makeStyles } from '@material-ui/styles';
import { IconButtonProps } from '../IconButton/index';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      borderRadius: palette.borderRadius.default,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '0',
      cursor: 'pointer',
      position: 'relative'
    },
    elevate: {
      background: palette.background.box,
      boxShadow: palette.shadows.boxShadow,
      transition: '0.4s ease',
      '@media (min-width: 1022px)': {
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow:
            '12px 12px 50px rgba(130, 130, 130, 0.25), -12px -12px 50px -2px rgba(160, 160, 160, 0.25)'
        }
      },
      '@media (max-width: 1022px)': {
        transition: '0.2s ease',
        '&:active': {
          transform: 'translateY(-12px)',
          boxShadow:
            '12px 12px 50px rgba(130, 130, 130, 0.25), -12px -12px 50px -2px rgba(160, 160, 160, 0.25)'
        }
      }
    },
    flat: {
      backgroundColor: (props: Partial<IconButtonProps>) => props.color,
      transition: 'transform 0.4s ease',
      '&:hover': {
        transform: 'translateY(-6px)',
        border: '2px solid grey'
      }
    },
    backless: {
      background: 'transparent',
      transition: '0.4s ease',
      '@media (min-width: 1022px)': {
        '&:hover': {
          transform: 'scale(1.2)'
        }
      },
      '@media (max-width: 1022px)': {
        transition: '0.2s ease',
        '&:active': {
          transform: 'scale(1.4)'
        }
      }
    },
    border: {
      border: `3px solid ${palette.background.autumn}`
    },
    normal: {
      height: '44px',
      width: '44px'
    },
    small: {
      height: '20px',
      width: '20px'
    },
    notifs: {
      position: 'absolute',
      bottom: '-2px',
      right: '-2px',
      color: palette.text.white,
      boxShadow: palette.shadows.boxShadow,
      backgroundColor: palette.background.autumn,
      padding: '3px 5px 2px 5px',
      borderRadius: palette.borderRadius.default
    },
    menuBurger: {
      borderRadius: '10px 0px 0px 10px'
    },
    '@keyframes load': {
      '0%': {
        background: palette.background.dark,
        border: '0px solid #fff'
      },
      '50%': {
        background: palette.background.dark,
        border: '8px solid #222'
      },
      '100%': {
        background: palette.background.dark,
        border: '0px solid #222'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
